//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 로고 이미지
import defaultLogo from "@/assets/images/logo/logo_am_white.png";
import onScrollLogo from "@/assets/images/logo/logo_am_blue.png";
import { mapActions, mapGetters } from "vuex";
import Cookie from "js-cookie";

export default {
	props: {},
	data() {
		return {
			// sitemap
			sitemapVisible: false,

			// sitemap submenu
			// sitemapSubMenu: true,

			// scroll
			scroll: false,

			// mouseover
			menuMouseOver: false,

			// 서브메뉴 스와이퍼
			subMenuSwiperOption: {
				slidesPerView: "auto",
				spaceBetween: 0,
				// slidesPerGroup: '6',
				// centeredSlides: true,
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				}
			},

			// logo img
			logoImg: true,
			defaultImg: defaultLogo,
			onScrollImg: onScrollLogo,

			// header search 관련 클래스
			isMenu: false,
			isSearch: false,

			// search input
			topSearchInput: "",

			// topSearchVisible: false,

			menuList: [],

			// 빠른 링크
			quickLinkList: [
				{
					linkTitle: "BOC"
				},
				{
					linkTitle: "Compression Mold"
				},
				{
					linkTitle: "Full pack TR"
				},
				{
					linkTitle: "Full molding"
				}
			],

			// 언어 선택
			langOptions: [
				{
					value: "KOR",
					label: "KOR"
				},
				{
					value: "ENG",
					label: "ENG"
				},
				{
					value: "CHN",
					label: "CHN"
				}
			],
			langOptionsValue: Cookie.get(this.$amConstant.AM_I18N_COOKIE_KEY),
		};
	},
	created() {
		if (!process.client) {
			return;
		}
		window.addEventListener("resize", this.onResize);
	},
	mounted() {
		if (!process.client) {
			return;
		}
		// 스크롤 관련
		window.addEventListener("scroll", this.onScroll);
	},
	destroyed() {
		if (!process.client) {
			return;
		}
		window.removeEventListener("resize", this.onResize);
	},

	beforeDestroy() {
		if (!process.client) {
			return;
		}
		// 스크롤 관련
		window.removeEventListener("scroll", this.onScroll);
	},
	watch: {
		// 페이지 이동 시
		$route() {
			this.manageStoreData();
			// 사이트맵 닫기
			this.sitemapVisible = false;
		},

		// 모달처럼 열릴 때 스크롤 막기 by lje
		sitemapVisible: function() {
			if (this.sitemapVisible) {
				document.documentElement.style.overflow = "hidden";
				return;
			}
			document.documentElement.style.overflow = "auto";
		},

		langOptionsValue(newVal,currentVal) {
			$nuxt.$i18n.setLocale(newVal);
			// this.setMenuList([]);

			this.setMaterialMenuListEmpty();
			this.setClassificationListEmpty();
			this.$fetch();
			this.$forceUpdate();

			document.body.classList.remove(currentVal);
			document.body.classList.add(newVal);
			// console.log("langOptionsValue", this.langOptionsValue)
		},

		// 메뉴 마우스 오버 시 로고 색 변경
		menuMouseOver() {
			if (!this.scroll) {
				this.logoImg = !this.menuMouseOver;
			}
		}
	},

	async fetch() {

		await this.manageStoreData();

	},
	computed: {
		availableLocales() {
			return this.$i18n.locales;
		}
	},

	methods: {
		//store 이벤트
		...mapActions({
			setMaterialMenuListEmpty : "menu/setMaterialMenuListEmpty",
			setMenuList: "menu/setMenuList",

			setClassificationListEmpty: "classification/setClassificationListEmpty",
			getFunctionListSidebar : "classification/getFunctionListSidebar",

			//menu test
			getMaterialMenuList: "menu/getMaterialMenuList",
			getMaterialMap: "menu/getMaterialMap",

			//
			getMarketList: "classification/getMarketList",
			getFunctionList: "classification/getFunctionList",
		}),

		...mapGetters({
			getMenuList: "menu/menuList",

		}),

		async manageStoreData(){
			await this.getMaterialMenuList();
			await this.getMaterialMap();
			await this.getMarketList();
			await this.checkMenuList();
			await this.getFunctionListSidebar();
			await this.getFunctionList();
		},

		async checkMenuList(){
			//세팅 필요

			let materialMenuList = await this.getMaterialMenuList();
			let productSubMenuList = this.setProductSubMenuList( _.cloneDeep( materialMenuList ) );

			let marketList = await this.getMarketList();
			let marketSubMenuList = this.setMarketSubMenuList( _.cloneDeep( marketList ) );

			let menuList = await this.fillMenuList( productSubMenuList, marketSubMenuList );

			this.menuList = menuList;

			await this.setMenuList( menuList );

			return this.getMenuList();
		},


		// 검색창 열기
		openSearch() {
			this.isMenu = false;
			this.isSearch = true;
			// this.topSearchVisible = true;

			// this.$refs.search.$el.getElementsByTagName("input")[0].focus(); // 자동 포커스 - 동작 안함.. 다시 찾아보기.
			let windowWidth = document.documentElement.clientWidth;

			// 모달처럼 열릴 때 스크롤 막기 by lje
			if (windowWidth <= 1024) {
				document.documentElement.style.overflow = "hidden";
			}
		},

		// 검색창 닫기
		closeSearch() {
			this.isMenu = true;
			this.isSearch = false;
			// this.topSearchVisible = false;
			let windowWidth = document.documentElement.clientWidth;

			// 스크롤 풀기 by lje
			if (windowWidth <= 1024) {
				document.documentElement.style = "auto";
			}
		},

		// 스크롤 관련
		onScroll(e) {
			// let scrollPosition = window.scrollY || document.documentElement.scrollTop;
			// console.log(scrollPosition, headerTop);

			let scrollPosition = document.querySelector("html").scrollTop;
			let headerHeight = document.getElementById("header").scrollHeight;

			// header scroll fixed
			if (scrollPosition > headerHeight) {
				this.scroll = true;
				this.logoImg = false;
			} else {
				this.scroll = false;
				this.logoImg = true;
			}
		},

		/**
		 * 메뉴리스트에 데이터를 채워줍니다.
		 */
		fillMenuList(productSubMenuList, marketSubMenuList) {
			const menuPrefix = this.$urlConstant.MENU_URL_PREFIX;
			const menuSuffix = this.$urlConstant.MENU_URL_SUFFIX;

			const menuList = [
				{
					menuUrl: menuPrefix.USER_INTRO + menuSuffix.INTRO.KCC,
					menuName: this.$t(`user_menu_kccIntro`),

					// sub menu
					subMenuList: [
						{
							subMenuUrl:
								menuPrefix.USER_INTRO + menuSuffix.INTRO.KCC,
							subMenuName: this.$t(`user_common_kccIntro`),

							// detail menu
							detailMenuBox: false,
							detailMenuItem: []
						},
						{
							subMenuUrl:
								menuPrefix.USER_INTRO + menuSuffix.INTRO.AM,
							subMenuName: this.$t(`user_common_kccIntro_kccam`),

							// detail menu
							detailMenuBox: false,
							detailMenuItem: []
						},
						{
							subMenuUrl:
								menuPrefix.USER_INTRO +
								menuSuffix.INTRO.GLOBAL_NETWORK,
							subMenuName: this.$t(`user_common_kccIntro_globalNetwork`),

							// detail menu
							detailMenuBox: false,
							detailMenuItem: []
						},
						{
							subMenuUrl:
								menuPrefix.USER_INTRO +
								menuSuffix.INTRO.NEWSROOM.LIST,
							subMenuName: this.$t(`user_common_kccIntro_newsRoom`),

							// detail menu
							detailMenuBox: false,
							detailMenuItem: []
						}
					],

					// sitemap submenu
					sitemapSubMenuVisible: true
				},
				{
					menuUrl: menuPrefix.USER_PRODUCT + menuSuffix.PRODUCT.MAIN,
					menuName: this.$t(`user_menu_product`),

					// sub menu
					subMenuList: productSubMenuList,

					// sitemap submenu
					sitemapSubMenuVisible: true
				},
				{
					menuUrl: menuPrefix.USER_MARKET + menuSuffix.MARKET.MAIN,
					menuName: this.$t(`user_menu_market`),

					// sub menu
					subMenuList: marketSubMenuList,

					// sitemap submenu
					sitemapSubMenuVisible: true
				},
				{
					menuUrl:
						menuPrefix.USER_PRODUCT_SUPPORT +
						menuSuffix.PRODUCT_SUPPORT.INTEGRATED_SEARCH,
					menuName: this.$t(`user_menu_productSupport`),

					// sub menu
					subMenuList: [
						{
							subMenuUrl:
								menuPrefix.USER_PRODUCT_SUPPORT +
								menuSuffix.PRODUCT_SUPPORT.INTEGRATED_SEARCH,
							subMenuName:
								this.$t(`integratedSearch_tit`),

							// detail menu
							detailMenuBox: false,
							detailMenuItem: []
						},
						{
							subMenuUrl:
								menuPrefix.USER_PRODUCT_SUPPORT +
								menuSuffix.PRODUCT_SUPPORT.TECHNICAL_SUPPORT,
							subMenuName:
								this.$t(`integratedSearch_tecSupport_tit`),

							// detail menu
							detailMenuBox: false,
							detailMenuItem: []
						},
						{
							subMenuUrl:
								menuPrefix.USER_PRODUCT_SUPPORT +
								menuSuffix.PRODUCT_SUPPORT.PRODUCT_CATALOG,
							subMenuName:
								this.$t(`productSupport_productCatalog_tit`),

							// detail menu
							detailMenuBox: false,
							detailMenuItem: []
						}
					],

					// sitemap submenu
					sitemapSubMenuVisible: true
				},
				{
					menuUrl:
						menuPrefix.USER_CUSTOMER_SUPPORT +
						menuSuffix.CUSTOMER_SUPPORT.INQUIRY,
					menuName: this.$t(`user_menu_customerSupport`),

					// sub menu
					subMenuList: [
						{
							subMenuUrl:
								menuPrefix.USER_CUSTOMER_SUPPORT +
								menuSuffix.CUSTOMER_SUPPORT.INQUIRY,
							subMenuName: this.$t(`user_customerSupportInquiry_swal_inquiry`),

							// detail menu
							detailMenuBox: false,
							detailMenuItem: []
						},
						{
							subMenuUrl:
								menuPrefix.USER_CUSTOMER_SUPPORT +
								menuSuffix.CUSTOMER_SUPPORT.CONTACT,
							subMenuName: this.$t(`user_customerSupportContact_header_tit`),

							// detail menu
							detailMenuBox: false,
							detailMenuItem: []
						}
					],

					// sitemap submenu
					sitemapSubMenuVisible: true
				}
			];

			return menuList;
		},

		/**
		 * 제품 서브메뉴 리스트를 만들어줍니다.
		 */
		setProductSubMenuList(data) {
			let productSubMenuList = [];
			let materialMap = {};
			let _self = this;

			_.each(data, function(item) {
				let detailMenuItem = [],
					productDetailMenuObject = {},
					applicationDetailMenuObject = {};

				if (item.productClassificationList.length > 0) {
					productDetailMenuObject = _self.setProductDetailMenuObject(
						item.productClassificationList,
						item.oid
					);
					detailMenuItem.push(productDetailMenuObject);
				}

				if (item.applicationList.length > 0) {
					applicationDetailMenuObject = _self.setApplicationDetailMenuObject(
						item.applicationList,
						item.oid
					);
					detailMenuItem.push(applicationDetailMenuObject);
				}

				const subMenuUrl =
					_self.$store.$urlConstant.MENU_URL_PREFIX.USER_PRODUCT +
					_self.$store.$urlConstant.MENU_URL_SUFFIX.PRODUCT
						.MATERIAL_VIEW;
				let subMenuObject = {
					subMenuUrl: subMenuUrl + "?depth=1&partOid=" + item.oid,
					subMenuName: item.name,
					detailMenuBox: false,
					detailMenuItem: detailMenuItem,
					mainImg : item.mainImg,
				};

				materialMap[item.oid] = {
					materialClass: _.kebabCase(_.lowerCase(item.name)),
					materialName: item.name
				};
				productSubMenuList.push(subMenuObject);
			});

			return productSubMenuList;
		},

		/**
		 *제품 상세메뉴 제품구분 리스트를 만들어줍니다.
		 */
		setProductDetailMenuObject(productClassificationList, partOid) {
			let productDetailMenuObject = {
				menuTitle: this.$store.$amConstant.CLASSIFICATION
					.PRODUCT_CLASSIFICATION,
				detailMenuList: []
			};

			if (productClassificationList.length === 0) {
				return {};
			}

			let detailMenuList = [];
			const url =
				this.$store.$urlConstant.MENU_URL_PREFIX.USER_PRODUCT +
				this.$store.$urlConstant.MENU_URL_SUFFIX.PRODUCT
					.CLASSIFICATION_VIEW;
			_.each(productClassificationList, function(item) {
				let detailMenuObject = {
					detailMenuUrl : url + "?depth=2&partOid=" + partOid + "&classificationOid=" + item.oid + "&classification=product",
					detailMenuName: item.name
				};

				detailMenuList.push(detailMenuObject);
			});

			productDetailMenuObject.detailMenuList = detailMenuList;

			return productDetailMenuObject;
		},

		/**
		 * 제품 상세메뉴 Application 리스트를 만들어줍니다.
		 *
		 * @param applicationList
		 * @returns {{}}
		 */
		setApplicationDetailMenuObject(applicationList, partOid) {
			let applicationDetailMenuObject = {
				menuTitle: this.$store.$amConstant.CLASSIFICATION.APPLICATION,
				detailMenuList: []
			};

			if (applicationList.length === 0) {
				return {};
			}

			let detailMenuList = [];
			const url =
				this.$store.$urlConstant.MENU_URL_PREFIX.USER_PRODUCT +
				this.$store.$urlConstant.MENU_URL_SUFFIX.PRODUCT
					.APPLICATION_VIEW;
			_.each(applicationList, function(item) {
				let detailMenuObject = {
					detailMenuUrl: url + "?depth=2&partOid=" + partOid + "&classificationOid=" + item.oid + "&classification=application",
					detailMenuName: item.name
				};

				detailMenuList.push(detailMenuObject);
			});

			applicationDetailMenuObject.detailMenuList = detailMenuList;

			return applicationDetailMenuObject;
		},

		/**
		 * 마켓 서브메뉴 리스트
		 * @param data
		 * @returns {[]}
		 */
		setMarketSubMenuList(data) {
			let marketSubMenuList = [];
			let _self = this;

			_.each(data, function(item) {
				let detailMenuItem = [];

				let subMenuObject = {
					subMenuUrl: item.linkUrl,
					subMenuName: item.title,
					detailMenuBox: false,
					detailMenuItem: detailMenuItem
				};

				marketSubMenuList.push(subMenuObject);
			});

			return marketSubMenuList;
		},

		// 반응형 이벤트
		onResize(e) {
			let windowWidth = document.documentElement.clientWidth;

			// 모바일 사이즈일 경우 서브메뉴 가리기 (메인메뉴 클릭 시 밑으로 나오게 변경.)
			// if (windowWidth <= 1024) {
			//     this.menuList.forEach((item, index) => {
			//         item.sitemapSubMenuVisible = false;
			//     });
			// } else {
			//     this.menuList.forEach((item, index) => {
			//         item.sitemapSubMenuVisible = true;
			//     });
			// }
		},

		integratedSearch() {
			const _self = this;

			if (_self.$common.isEmpty(_self.topSearchInput)) {
				this.$common.confirmSwal( this.$t( `user_common_confirmSwal_noSearchInput` ), this.$t( `user_common_confirmSwal_noSearchInput_desc` ), "warning" );
				return;
			}

			_self.$router.push(
				this.localePath({
					path:
						_self.$urlConstant.MENU_URL_PREFIX
							.USER_PRODUCT_SUPPORT +
						_self.$urlConstant.MENU_URL_SUFFIX.PRODUCT_SUPPORT
							.INTEGRATED_SEARCH,
					query: {
						searchInput: _self.topSearchInput,

						depth: 1,
						productListPage: 1,
						applicationListPage: 1,
						marketListPage: 1,
						functionListPage: 1
					}
				})
			);
		}
	}
};
